import { ITEM_CATEGORIES, type ItemCategory } from "@stocks/shared";

export const ITEM_CATEGORY_LABELS: Record<ItemCategory, string> = {
  [ITEM_CATEGORIES.FABRIC]: "원단",
  [ITEM_CATEGORIES.TRIM]: "부자재",
  [ITEM_CATEGORIES.LABEL]: "라벨",
};

export const getCategoryLabel = (category: ItemCategory | null | undefined) =>
  category ? ITEM_CATEGORY_LABELS[category] : "-";
